import { serviceRoles } from "config/access";
import { STUDENT } from "constants/routes";
import { checkAccess } from "helpers/auth";
import StudentPage from "./container/StudentPage";

export default function getSettingsRoute(userAuth) {
  const { account, harmony } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [harmony.name]: [harmony.roles.admin],
    [harmony.gateway]: [harmony.roles.gateway],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: STUDENT,
    withSidebar: true,
    withAppBar: true,
    component: StudentPage,
  };
}
